export const introInfo = [
    {
        key: 0,
        title: '동아리원 관리',
        description: '동아리원 추가, 삭제, 수정을 할 수 있어요',
    },
    {
        key: 1,
        title: '기수 관리',
        description: '동아리원을 기수에 추가, 삭제, 수정을 할 수 있어요',
    },
    {
        key: 2,
        title: '역할 관리',
        description: '역할군을 관리할 수 있어요',
    },
    {
        key: 3,
        title: '전체',
        description: '홈페이지에 게재된 앱 정보와 목록을 관리할 수 있어요',
    },
    {
        key: 4,
        title: '질문 관리',
        description: '질문과 답변을 추가, 삭제, 수정을 할 수 있어요',
    },
    {
        key: 5,
        title: '앱 관리',
        description: '홈페이지에 게재된 앱 정보와 목록을 관리할 수 있어요',
    },
];
